<template>
    <div class="media-container">
        <headline :params="headLines" />
        <div class="mediaContent">
            <div class="mediaTitle">
                <img src="../../assets/img/analysis/pic.png" alt="">
                <div class="title">
                    <p class="l">媒体订阅</p>
                    <p class="n">海量资讯实时更新，丰富信息一手掌握</p>
                </div>
                <div class="btns">
                    <p @click="addBoard(0)" class="btn add">
                        <i></i>
                        <span>添加看板</span>
                    </p>
                    <p @click="mediaSort" class="btn sort">
                        <i class="sort"></i>
                        <span>调整顺序</span>
                    </p>
                </div>
            </div>

            <div v-if="list.length === 0" class="emptyMedia">
                <img src="../../assets/img/analysis/emptyPic.png" alt="">
                <span>暂无看板</span>
            </div>

            <ul v-if="list.length > 0" class="content">
                <li v-for="item in list" :key="item.id">
                    <div class="title-container">
                        <div class="title-content">
                            <p class="title">{{item.title}}</p>
                            <i class="more">
                                <div class="span">
                                    <span></span>
                                    <ul>
                                        <li @click="addBoard(1,item.id)" class="edit">
                                            <i></i>
                                            <span>修改</span>
                                        </li>
                                        <li @click="delboard(item.id)" class="del">
                                            <i></i>
                                            <span>删除</span>
                                        </li>
                                    </ul>
                                </div>
                            </i>
                        </div>
                    </div>
                    <div v-if="item.contents.length === 0" class="empty">
                        <img src="../../assets/img/analysis/emptyPic.png" alt="">
                        <span>暂无信息</span>
                    </div>
                    <ul v-if="item.contents.length > 0" class="content-list">
                        <li @click="getDetail(item.hb_id, items.content_id, items.type)" v-for="(items,index) in item.contents" :key="index" class="content">
                            <div class="infoContent">
                                <div class="title">{{items.title}}</div>
                                <div class="info">
                                    <span>{{items.client_name}}</span>
                                    <span>{{items.raw_add_time}}</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div v-if="item.contents.length > 0" @click="toDetail(item.id)" class="checkAll">
                        <span>查看全部</span>
                        <i></i>
                    </div>
                </li>
            </ul>
        </div>
        <div @click="addBoard(0)" v-if="showAdd" class="addNew"></div>
        <transferBox :config="config" @submit="submit" @close="showCreate = false" :mediaList="mediaList" :transferBoxTitle="transferBoxTitle" v-if="showCreate"></transferBox>
    </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import headline from "@components/headline";
import transferBox from "@components/transferBox";

export default {
    components: {
        headline,
        transferBox
    },
    data() {
        return {
            showAdd: false,
            showCreate: false,
            fontSize: 100,
            headLines: {
                title: "",
                showLink: false,
                filter: false
            },
            list: [],
            mediaList: [],
            config: {

            }
        }
    },
    methods: {
        addScroll() {
            window.addEventListener('scroll', this.handleScroll)
        },
        handleScroll() {
            const bodyheight = document.body.clientHeight
            let scrollTop = window.document.documentElement.scrollTop || window.document.body.scrollTop

            if (scrollTop > bodyheight / 3) {
                this.showAdd = true
            } else {
                this.showAdd = false
            }
        },
        toDetail(id) {
            common.jump(`/mtkbDetail?d=${id}`, false);
        },
        submit(info) {
            common.myFetch(apis.editboard, info).then(res => {
                if(res){
                    this.$toast(res)
                    if(res != '媒体看板名称不能重复'){
                        this.showCreate = false
                        this.getList()
                    }
                }
            })
        },
        async addBoard(type,id) {
            this.getMedias('', '', id)
            if(type - 0 === 0){
                this.transferBoxTitle = '添加看板'
                this.config.title = ''
                this.config.clients = []
                this.config.need_push = 1
                this.config.id = ''
            }else{
                this.transferBoxTitle = '编辑看板'
                await this.getBoard(id)
            }
            this.showCreate = true
        },
        getMedias(type, keyword, board_id) {
            let info = {
                type: type || '',
                keyword: keyword || '',
                board_id: board_id || ''
            }
            common.myFetch(apis.medias, info).then(res => {
                if(res){
                    this.mediaList = res.list
                    console.log(res)
                }
            })
        },
        getBoard(id) {
            let info = {
                board_id: id || ''
            }
            common.myFetch(apis.boardinfo, info).then(res => {
                if(res){
                    console.log(res)
                    res.detail.clients.forEach(item => {
                        item.selected = false;
                    });
                    this.config = res.detail
                }
            })
        },
        mediaSort() {
            this.$MediaSort(this.list).then(res => {
                if(res){
                    let info = {
                        sort: JSON.stringify(res)
                    }
                    common.myFetch(apis.setsort, info).then(res => {
                        if(res){
                            this.$toast(res)
                            this.getList()
                        }
                    })
                }
            })
        },
        getDetail(hbid, id, type) {
            console.log(hbid, id, type)
            let info = {
                hb_id: hbid,
                content_id: id
            }
            if(type === 'content'){
                common.myFetch(apis.boardcontent, info).then(res => {
                    if(res){
                        console.log(res)
                        this.$ArticlePreview(res.detail)
                    }
                })
            }else{
                common.myFetch(apis.boardvideo, info).then(res => {
                    if(res){
                        console.log(res)
                        this.$MediaPreview(res.detail)
                    }
                })
            }
        },
        delboard(id) {
            let info = {
                id: id
            }
            common.myFetch(apis.delboard, info).then(res => {
                if(res){
                    this.$toast(res)
                    this.getList()
                }
            })
        },
        getList() {
            common.myFetch(apis.sentimentboards).then(res => {
                if(res){
                    this.list = res.list
                }
            })
        },
        recalc() {
            var clientWidth = document.documentElement.clientWidth;

            if (!clientWidth) {

                return;
            }

            var p = 100 * (clientWidth / 1334);

            this.fontSizeWrite = p

            if(p<97.3){
                p=97.3
            }

            this.fontSize = 100
        }
    },
    beforeDestroy() {
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
        window.removeEventListener(resizeEvt, this.recalc, false);
    },
    mounted() {
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';

        window.addEventListener(resizeEvt, this.recalc, false);

        this.recalc()
        
        this.addScroll()

        const oMeta = document.createElement('meta');
        oMeta.name = "referrer";
        oMeta.content = "no-referrer"
        document.getElementsByTagName('head')[0].appendChild(oMeta);

        // this.$MediaSort()
    },
    created() {
        this.headLines.title = '媒体看板'
        this.getList()
        let type = this.$route.query.type
        let hb_id = this.$route.query.hb_id
        let content_id = this.$route.query.content_id
        if(type && hb_id && content_id){
            this.getDetail(hb_id, content_id, type)
        }
    }
}
</script>

<style scoped lang="less">
    .media-container {
        .mediaContent {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 30px 67px 50px;
            box-sizing: border-box;
            height: calc(100vh - 70px);

            .mediaTitle {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                width: 1200px;
                height: 144px;
                background: #FFFFFF;
                margin-bottom: 30px;
                padding: 0 70px 0 24px;
                box-sizing: border-box;

                img {
                    width: 470px;
                    height: 144px;
                }

                .title {
                    display: flex;
                    flex-direction: column;
                    font-weight: 500;

                    .l {
                        position: relative;
                        font-size: 27px;
                        line-height: 38px;
                        color: #050F0F;
                        z-index: 1;

                        &:after {
                            position: absolute;
                            bottom: 3px;
                            left: 0;
                            z-index: -1;
                            display: block;
                            content: '';
                            width: 104px;
                            height: 10px;
                            background: #65DEB4;
                            border-radius: 2px;
                        }
                    }

                    .n {
                        font-size: 20px;
                        line-height: 38px;
                        color: #050F0F;
                    }
                }

                .btns {
                    width: 148px;

                    .btn {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        user-select: none;
                        cursor: pointer;

                        &.add {
                            width: 148px;
                            height: 40px;
                            background: #41B48C;
                            border-radius: 20px;
                            margin-bottom: 10px;

                            i {
                                display: block;
                                width: 14px;
                                height: 14px;
                                background: url('../../assets/img/analysis/whiteAdd.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                margin-right: 8px;
                            }   

                            span {
                                font-size: 14px;
                                line-height: 20px;
                                color: #FFFFFF;
                            }
                        }

                        &.sort {
                            width: 148px;
                            height: 40px;
                            background: #FFF;
                            border-radius: 20px;
                            border: 1px solid #41B48C;
                            box-sizing: border-box;

                            i {
                                display: block;
                                width: 14px;
                                height: 14px;
                                background: url('../../assets/img/analysis/sort.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                margin-right: 8px;
                            }   

                            span {
                                font-size: 14px;
                                line-height: 20px;
                                color: #41B48C;
                            }
                        }
                    }
                }
            }

            .emptyMedia {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 1200px;
                flex: 1;
                background: #FFFFFF;
                box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                border-radius: 4px;

                img {
                    width: 102px;
                    height: 60px;
                    margin-bottom: 20px;
                }

                span {
                    font-size: 16px;
                    line-height: 22px;
                    font-weight: 500;        
                    color: #B9C3C3;
                }
            }

            &>.content {
                width: 1200px;
                display: flex;
                flex-direction: row;
                // justify-content: space-between;
                flex-wrap: wrap;

                & > li {
                    display: flex;
                    flex-direction: column;
                    position: relative;
                    width: 388px;
                    height: 597px;
                    background: #FFFFFF;
                    box-shadow: 4px 4px 1px 0px rgba(5, 10, 15, 0.05);
                    border-radius: 4px;
                    margin-bottom: 18px;
                    margin-right: 18px;

                    &:nth-child(3n) {
                        margin-right: 0px;
                    }

                    &>.title-container {
                        padding: 0px 24px;
                        box-sizing: border-box;

                        .title-content {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;
                            width: 100%;
                            padding: 17px 0 17px 12px;
                            border-bottom: 1px solid #DCDCDC;
                            box-sizing: border-box;

                            .title {
                                position: relative;
                                font-size: 16px;
                                line-height: 22px;
                                color: #050F0F;
                                font-weight: 500;

                                &::after {
                                    position: absolute;
                                    top: 50%;
                                    left: -12px;
                                    margin-top: -6.5px;
                                    display: block;
                                    content: '';
                                    width: 4px;
                                    height: 14px;
                                    background: #41B48C;
                                }
                            }

                            .more {
                                position: relative;
                                display: block;
                                width: 16px;
                                height: 16px;
                                background: url('../../assets/img/analysis/more.png') no-repeat;
                                background-size: 100% 100%;
                                background-position: center center;
                                user-select: none;
                                cursor: pointer;

                                &:hover {
                                    background: url('../../assets/img/analysis/moreOn.png') no-repeat;
                                    background-size: 100% 100%;
                                    background-position: center center;
                                    .span {
                                        display: flex;
                                    }
                                }

                                .span {
                                    position: absolute;
                                    top: 16px;
                                    right: -10px;
                                    display: none;
                                    flex-direction: column;

                                    &>span {
                                        display: block;
                                        width: 120px;
                                        height: 6px;
                                    }
                                }

                                ul {
                                    width: 120px;
                                    background: rgba(5, 15, 15, 0.8);
                                    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                                    border-radius: 4px;

                                    li {
                                        display: flex;
                                        flex-direction: row;
                                        justify-content: center;
                                        align-items: center;
                                        width: 100%;
                                        height: 40px;

                                        i {
                                            display: block;
                                            width: 16px;
                                            height: 16px;
                                            margin-right: 10px;
                                        }

                                        span {
                                            font-size: 13px;
                                            line-height: 18px;
                                            color: #B9C3C3;
                                            font-weight: 500;
                                        }

                                        &:hover {
                                            background: rgba(255, 255, 255, 0.1);
                                        
                                            &.edit {
                                                i {
                                                    background: url('../../assets/img/analysis/editOn.svg') no-repeat;
                                                    background-position: center center;
                                                    background-size: 100% 100%;
                                                }
                                            }

                                            &.del {
                                                i {
                                                    background: url('../../assets/img/analysis/delOn.svg') no-repeat;
                                                    background-position: center center;
                                                    background-size: 100% 100%;
                                                }
                                            }

                                            span {
                                                color: #FFF;
                                                font-weight: bold;
                                            }
                                        }

                                        &.edit {
                                            i {
                                                background: url('../../assets/img/analysis/edit.svg') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                            }
                                        }

                                        &.del {
                                            i {
                                                background: url('../../assets/img/analysis/del.svg') no-repeat;
                                                background-position: center center;
                                                background-size: 100% 100%;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .empty {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        width: 100%;
                        flex: 1;

                        img {
                            width: 102px;
                            height: 60px;
                            margin-top: 150px;
                            margin-bottom: 20px;
                        }

                        span {
                            font-size: 16px;
                            line-height: 22px;
                            color: #B9C3C3;
                        }
                    }

                    .content-list {
                        display: flex;
                        flex-direction: column;
                        
                        .content {
                            padding: 0 24px;
                            box-sizing: border-box;

                            &:hover {   
                                background: rgba(185, 195, 195, 0.15);
                            }

                            .infoContent {
                                padding: 19px 0;
                                border-bottom: 1px solid #DCDCDC;
                                box-sizing: border-box;

                                .title {
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #050F0F;
                                    font-weight: 500;
                                    margin-bottom: 6px;
                                    word-wrap: break-word;
                                    overflow: hidden;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                }

                                .info {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;

                                    span {
                                        display: block;
                                        font-size: 12px;
                                        line-height: 17px;
                                        color: #829191;

                                        &:nth-of-type(1) {
                                            margin-right: 16px;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .checkAll {
                        position: absolute;
                        bottom: 16px;
                        left: 50%;
                        transform: translateX(-50%);
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        user-select: none;
                        cursor: pointer;

                        span {
                            font-size: 12px;
                            line-height: 17px;
                            color: #323B4B;
                        }

                        i {
                            display: block;
                            width: 16px;
                            height: 10px;
                            background: url('../../assets/img/analysis/arrow.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                        }
                    }
                }
            }
        }

        .addNew {
            position: fixed;
            right: 30px;
            bottom: 92px;
            cursor: pointer;
            z-index: 999;
            width: 46px;
            height: 46px;
            background: url('../../assets/img/analysis/addBtn.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
        }
    }
</style>